import * as React from 'react'

import { ButtonBase, Grid, Tooltip } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import IconPicker from '../../../features/apps/AppComponents/IconPicker/IconPicker'
import {
  MyAlertsAndNotifications,
  VisitorModeLabel,
} from './DashboardLocalButtons'

const useStyles = makeStyles((theme) => ({
  emergencyInfoIcon: {
    padding: theme.spacing(1),
    '&:focus-visible': {
      outline: `1px solid ${theme.palette.button.focusBorder}`,
      boxShadow: `0 0 0 3px ${theme.palette.button.focusOutline}`,
      backgroundColor: theme.palette.action.focus,
      borderRadius: '100%',
    },
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: theme.palette.button.hover,
      borderRadius: '25px',
    },
  },
  visitorModeLabel: {
    background: theme.palette.components.visitorLabel,
    color: theme.palette.paper.primary,
    borderRadius: '1rem',
    padding: '2px 3px',
    textAlign: 'center',
    marginRight: '10px',
    width: '120px',
    fontSize: '17px',
  },
  visitorModeLabelMobile: {
    background: theme.palette.components.visitorLabel,
    color: theme.palette.paper.primary,
    borderRadius: '1rem',
    padding: '0px',
    marginTop: '2px',
    textAlign: 'center',
    width: '80px',
  },
}))

export default function SettingsLocalButtons({
  history,
  isMobile,
  activeAlerts,
  activeNotificationList,
  alertsClasses,
  dispatch,
  dialogOpen,
}) {
  const classes = useStyles()
  const handleEmergencyContactClick = () => {
    history.push('/settings/emergencyInformation')
  }
  const isGuest =
    localStorage.getItem('user') === '"visitor"' ||
    localStorage.getItem('user') === ''
  return (
    <>
      <Grid item md={4}>
        <Grid
          container
          justifyContent="flex-end"
          alignItems="center"
          style={{ paddingRight: 10 }}
        >
          {!isMobile ? (
            <Grid item style={{ marginRight: 4 }}>
              <VisitorModeLabel classes={classes} />
            </Grid>
          ) : null}
          <Grid item style={{ display: 'flex' }}>
            <MyAlertsAndNotifications
              dispatch={dispatch}
              isMobile={isMobile}
              isGuest={isGuest}
              classes={alertsClasses}
              activeAlerts={activeAlerts}
              activeNotificationList={activeNotificationList?.length}
              dialogOpen={dialogOpen}
            />
          </Grid>
          <Grid item>
            <Tooltip title="Emergency Information">
              <ButtonBase
                onClick={() => handleEmergencyContactClick()}
                aria-label="Emergency Information"
                className={classes.emergencyInfoIcon}
              >
                <IconPicker
                  iconName="fa-shield-alt"
                  color="#c41f32"
                  size="3x"
                />
              </ButtonBase>
            </Tooltip>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}
